import { Fragment } from 'react/jsx-runtime'

import { useModalStackStore as store } from './store'

/**
 * ModalStack is a component that renders a stack of modals.
 *
 * It is used to render modals in a stack, so that the modals are rendered in the order they are added.
 * It is also used to render the modals in the correct order, so that the modals are rendered in the correct order.
 * Modals should be rendered in a portal, so they are rendered in a separate DOM element. This should naturally have the highest z-index.
 * ModalStack does not render the modals, it only returns the modals. Creating the portal is the responsibility of the parent component.
 * Modals are also rendered in a different React tree, so they are not affected by state changes in the parent component.
 * Models are added using DOM events, so they are not affected by state changes in the parent component.
 * Modals are also removed using DOM events, so they are not affected by state changes in the parent component.
 * Keep in mind that any dependant Providers will need to be available either in the parent component of the ModalStack component or in the ModalStack component itself.
 *
 * @returns An array of modal components.
 */
export const ModalStack = () => {
    return store((state) => state.modals).map(
        ({ id, component: Component }) => (
            <Fragment key={id}>{Component}</Fragment>
        ),
    )
}

export default ModalStack
